import modal from './modal.connect'

export default modal
